import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PaymentV2Service, UtilService } from '../../shared/services';

@Component({
  selector: 'app-payment-method-list',
  templateUrl: './payment-method-list.component.html',
  styleUrls: ['./payment-method-list.component.scss']
})
export class PaymentMethodListComponent implements OnInit, OnChanges {

  @Input() config;
  @Input() listConfig;
  @Output() submitPayment = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Output() onRadioBtn = new EventEmitter();

  filteredList;
  selectedOption;

  constructor(
    public util: UtilService,
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
    // this.filteredList = this.listConfig?.list;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.filteredList = this.listConfig?.list;
    if (changes?.listConfig?.currentValue?.selected) {
      this.selectedOption = changes?.listConfig?.currentValue?.selected;
    }
  }

  search(value) {
    this.filteredList = this.util.filterObject(this.listConfig?.list, value);
  }

}
